export const ROUTES = {
  HOME: '/',
  FEATURES: '/features',
  PRICING: '/pricing',
  QA: '/qa',
  FAQ: '/faq',
  LOGIN: '/login',
  SIGNUP: '/signup',
  CONTACT_SALES: '/contact-sales',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  BLOG: '/blog',
  DIRECTORY: '/directory',
  EVENTS: '/events',
  FOR_MEDSPA: '/for-medspa',
  VS_MINDBODY: '/vs-mindbody',
};
